"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorExtractLinksPredicates = void 0;
const bus_extract_links_1 = require("@comunica/bus-extract-links");
/**
 * A comunica Traverse Predicates RDF Metadata Extract Actor.
 */
class ActorExtractLinksPredicates extends bus_extract_links_1.ActorExtractLinks {
    constructor(args) {
        super(args);
        this.predicates = args.predicateRegexes.map(stringRegex => new RegExp(stringRegex, 'u'));
    }
    async test(action) {
        return true;
    }
    async run(action) {
        return {
            links: await bus_extract_links_1.ActorExtractLinks.collectStream(action.metadata, (quad, links) => {
                if (!this.checkSubject || this.subjectMatches(quad.subject.value, action.url)) {
                    for (const regex of this.predicates) {
                        if (regex.test(quad.predicate.value)) {
                            links.push({ url: quad.object.value });
                            break;
                        }
                    }
                }
            }),
        };
    }
    subjectMatches(subject, url) {
        const fragmentPos = subject.indexOf('#');
        if (fragmentPos >= 0) {
            subject = subject.slice(0, fragmentPos);
        }
        return subject === url;
    }
}
exports.ActorExtractLinksPredicates = ActorExtractLinksPredicates;
//# sourceMappingURL=ActorExtractLinksPredicates.js.map